/**
 * MRT 모달 템플릿
 */

import { Box, Modal, Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { COLORS, FONT_PROPS } from "../../styles/colors";

//import { useState } from "react";

const ModalContainer = styled(Box)(({ theme }) => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    borderRadius: "8px",
    boxShadow: 24,
    padding: theme.spacing(4),
}));

// 모달 템플릿
export function ModalTemplate({
    isOpen = false, // 모달 열림 여부
    handleConfirm = null,
    handleCancel = null,
    title = "", 
    cancelText = "취소",
    confirmText = "확인",
    children, // 모달 내용
    containerSX={}, // modal containder 커스텀 스타일
    titleSX={}, // 타이틀 커스텀 스타일
    contentSX ={}, //  내용 contents 커스텀 스타일
    enableToolBarBottomLine = true, // 툴바 하단 라인
    enableSingleActionButton = false, // 단일 액션 버튼 활성화 여부
}) {

    //const [isOpen, setIsOpen] = useState(true);
    //console.log("모달 렌더링");

    // 렌더링
    return (
      <Modal 
        //open={isOpen}
        open={isOpen}
        onClose={handleCancel}
      >
        <ModalContainer
          role="dialog"
          aria-modal="true"
          aria-label={title || "대화상자"}
          sx={{ 
          //background: COLORS.BACKGROUND_BRIGHTER,
          //width: 'auto',
          //minWidth: '25%',
          //maxWidth: '90%',
          //maxHeight: '90vh',  // ✅ 전체 제한
          display: 'flex',
          flexDirection: 'column',
          ...containerSX,
          }}
        >
          {/* 타이틀 */}
          <Box
            sx={{
              fontSize: "18px",                
              fontWeight: FONT_PROPS.MEDIUM,
              color: FONT_PROPS.DARK,
              padding: enableToolBarBottomLine ? "0px 0px 20px 0px" : "0px",
              borderBottom: enableToolBarBottomLine ? `1px solid ${COLORS.BORDER_BRIGHT}` : "none",
              ...titleSX,
            }}
          >
            {title}
          </Box>
          {/* 내용 contents */}
          <Box sx={{
            display: "flex",
            flex: 1,
            //flexDirection: "column",
            minHeight: 0, // 내용물이 모달의 범위에 벗어나지 않게 하는 핵심 CSS
            //gap: "20px",
            padding: "12px 0px 12px 0px",
            ...contentSX, // contentSX가 있으면 덮어씌움
          }}>
            {children}
          </Box>
            
          {/* 버튼 */}
          {enableSingleActionButton ? (
            <Box
              sx={{
                px: 3,
                py: 2,
                borderTop: '1px solid #eee',
                display: 'flex',
                justifyContent: 'flex-end',
                gap: 2,
              }}
            >
              <Button variant="contained" onClick={handleConfirm}>{confirmText}</Button>
            </Box>
          ) : (
            <Box
              sx={{
                px: 3,
                py: 2,
                borderTop: '1px solid #eee',
                display: 'flex',
                justifyContent: 'flex-end',
                gap: 2,
              }}
            > 
              <Button variant="outlined" onClick={handleCancel}>{cancelText}</Button>
              <Button variant="contained" onClick={handleConfirm}>{confirmText}</Button>
            </Box>
          )}
        </ModalContainer>
      </Modal>
    );
}

export function ModalFieldTemplate() {
    return (
        <></>
    );
}
